<template>
    <modal
        v-if="ShowModal"
        class="help-me-calculate-modal"
        @close="closeModal">
        <div
            slot="body"
            class="">
            <h3 v-html="PopupTitle"></h3>
            <div class="modal-content-wrapper">
                <div class="left-section">
                    <ul class="view-value">
                        <li>
                            <drop-down
                                v-model="Year"
                                :label="LabelModelYears"
                                :options="YearList"
                                @input="fetchMake($event, false)"
                            />
                        </li>
                        <li>
                            <drop-down-loader v-if="ShowLoaderMake" />
                            <drop-down
                                v-model="Make"
                                :label="LabelModelCompany"
                                :smalltext="companyModel"
                                :options="MakeList"
                                @input="fetchModel($event, false)"
                            />
                        </li>
                        <li>
                            <drop-down-loader v-if="ShowLoaderModel" />
                            <drop-down
                                v-model="Model"
                                :label="LabelModelName"
                                :smalltext="companyModelName"
                                :options="ModelList"
                                @input="fetchTrim($event, false)"
                            />
                        </li>
                        <li>
                            <drop-down-loader v-if="ShowLoaderTrim" />
                            <drop-down
                                v-model="Trim"
                                :label="LabelModelTrim"
                                :smalltext="companyModelTrim"
                                :options="TrimList"
                                @input="updateTrimConditionData"
                            />
                            <span
                                v-show="ShowTrimError"
                                class="error-msg">Please select trim.</span>
                        </li>
                        <li>
                            <drop-down
                                v-model="Condition"
                                :label="LabelModelCondition"
                                :tooltip-link="InterestRateTooltip"
                                show-tooltip="true"
                                :show-question-mark="ShowQuestionMark"
                                :popper-content="PopperContent"
                                class="tooltip-icon"
                                :options="ConditionList"
                                @input="updateTrimConditionData"
                            />
                        </li>
                        <li class="mileage">
                            <number-input
                                v-model="Mileage"
                                :label="LabelModelMileage"
                                symbol-aligned="none"
                                maxlength="6"
                                @input="trimValidationMileage()"
                            />
                            <span
                                v-show="ShowMileageError"
                                class="error-msg">Trade-in estimates are more accurate when mileage is included.</span>
                        </li>
                        <li>
                            <label>Zip Code</label>
                            <zip-code-input
                                v-model="ZipCode"
                                @input="getLocationByZip"
                            />
                            <span
                                v-show="ShowZipCodeError"
                                class="error-msg">Please enter a valid zip code.</span>
                        </li>
                    </ul>
                </div>
                <div class="right-section">
                    <img
                        class="kbb-logo"
                        src="../../../assets/images/kbb-logo.png"
                        alt="Kbb"
                    />
                    <label class="label-trade-value">Kelley Blue Book &#174; Trade-In Value
                        <span class="hidden-xs">
                            <tooltip-view
                                :show-question-mark="ShowQuestionMark"
                                :popper-content="PopperContent1"
                                reference-element="open me"
                                class="tooltip-icon"
                            />
                        </span>
                        <span class="visible-xs">
                            <tooltip-view
                                :show-question-mark="ShowQuestionMark"
                                :popper-content="PopperContentMob"
                                reference-element="open me"
                                class="tooltip-icon"
                            />
                        </span>
                    </label>
                    <h4>
                        ${{ convertCurrency(ConditionValue) }}
                        <div
                            v-if="ShowLoader"
                            class="loader loader-result">
                            <img
                                alt="lt-loader"
                                width="61"
                                height="60"
                                src="data:image/png;base64,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"
                            />
                        </div>
                    </h4>
                    <span>{{ Year == 0 ? '' : Year + " " + fetchSelectedValue(MakeList, Make) + " " + fetchSelectedValue(ModelList, Model) }}  </span>
                    <a
                        class="btn btn-orange"
                        @click="udpdateTrdeIn">Use this Value</a>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import Accounting from 'accounting';
    import { debounce } from 'lodash-es';
    import Modal from '~/components/modal.vue';
    import BaseMixin from '~/mixin/base-mixin';
    import DefaultTooltip from '~/constants/tooltip-defaults';
    import TrimConditions from '~/constants/trim-conditions';
    import TooltipView from '~/components/tooltip-view.vue';
    import {
        getMakeList as getMakeListSvc, getModelList as getModelListSvc, getTrimList as getTrimListSvc, getMarketValues as getMarketValuesSvc,
    } from '~/services/tradeIn-service';
    import ZipCodeInput from '~/components/zip-code-input.vue';
    import GetLocation from '~/mixin/get-geo-location';
    import StringFormat from '~/helpers/string-format';
    import DropDownLoader from './drop-down-loader.vue';

    export default {
        components: {
            Modal,
            TooltipView,
            ZipCodeInput,
            DropDownLoader,
        },
        mixins: [BaseMixin, GetLocation],
        props: {
            showModal: {
                default: false,
            },
            popupTitle: {
                default: 'Just two quick questions before we get your quotes.',
            },
            labelModelYears: {
                default: 'Year',
            },
            labelModelCompany: {
                default: 'Make',
            },
            labelModelName: {
                default: 'Model',
            },
            labelModelTrim: {
                default: 'Trim*',
            },
            labelModelCondition: {
                default: 'Condition',
            },
            labelModelMileage: {
                default: 'Mileage',
            },
            interestRateTooltip: {
                default: DefaultTooltip.InterestRate,
            },
            companyModel: {
                default: 'e.g. Toyota',
            },
            companyModelName: {
                default: 'e.g. Camry',
            },
            companyModelTrim: {
                default: 'e.g. EXL',
            },
            showQuestionMark: {
                default: true,
            },
            popperContent: {
                default: '',
            },
            popperContent1: {
                default: '',
            },
            yearList: {
                default: [],
            },
            year: {
                default: 0,
            },
            make: {
                default: 0,
            },
            model: {
                default: 0,
            },
            trim: {
                default: 0,
            },
            condition: {
                default: 'Good',
            },
            zipCode: {
                default: '',
            },
            startDate: {
                default: '',
            },
            endDate: {
                default: '',
            },
            labelZipCode: {
                default: 'Zip Code',
            },
            mileage: {
                default: 0,
            },
        },
        data() {
            return {
                ShowModal: this.showModal,
                PopupTitle: this.popupTitle,
                LabelModelYears: this.labelModelYears,
                LabelModelCompany: this.labelModelCompany,
                LabelModelName: this.labelModelName,
                LabelModelTrim: this.labelModelTrim,
                LabelModelCondition: this.labelModelCondition,
                LabelModelMileage: this.labelModelMileage,
                InterestRateTooltip: parseInt(this.hideTooltip, 10) ? '' : this.interestRateTooltip,
                ShowQuestionMark: this.showQuestionMark,
                PopperContent: this.popperContent,
                PopperContent1: this.popperContent1,
                Year: this.year,
                Make: this.make,
                Model: this.model,
                YearList: this.yearList,
                Trim: this.trim,
                Condition: this.condition,
                ConditionList: TrimConditions,
                MakeList: [],
                ModelList: [],
                TrimList: [],
                ZipCode: this.zipCode,
                Mileage: this.mileage,
                IsDisabled: true,
                ConditionValue: 0,
                ShowMileageError: false,
                BaseTrim: 0,
                LabelZipCode: this.labelZipCode,
                ShowZipCodeError: false,
                Location: {},
                PopperContentMob: '',
                ShowLoader: false,
                TrimListCount: 0,
                ShowTrimError: false,
                ShowLoaderMake: false,
                ShowLoaderModel: false,
                ShowLoaderTrim: false,

            };
        },
        mounted() {
            // eslint-disable-next-line eqeqeq
            if (this.mileage == 0) {
                this.Condition = this.condition;
                this.ConditionValue = 0;
            }
            this.getLocationByZip(this.ZipCode);
            this.ShowModal = this.showModal;
            this.PopperContent = '<div class="popup-content large-content"><h4>Condition Definitions</h4> <span class="conditon-title">Excellent</span><p>"Excellent" condition means that the vehicle looks new and is in excellent mechanical condition. This vehicle has never had any paint or bodywork and does not need reconditioning. The engine compartment is clean and free of fluid leaks. This vehicle is free of rust. The body and interior are free of wear or visible defects. The tires all match and are like new. This vehicle has a clean title history and will pass a safety and smog inspection. This vehicle has complete and verifiable service records.</p><span class="conditon-title">Very Good</span><p> "Very Good" condition means that the vehicle has minor cosmetic defects and is in excellent mechanical condition. This vehicle has had minor or no paint or bodywork, and requires minimal reconditioning. The engine compartment is clean and free of fluid leaks. This vehicle is free of rust. The body and interior have minimal signs of wear or visible defects. The tires all match and have 75% or more of tread remaining. This vehicle has a clean title history and will pass a safety and smog inspection. Most service records are available.</p><span class="conditon-title">Good</span> <p>"Good" condition means that the vehicle has some cosmetic repairable defects and is free of major mechanical problems. The paint and bodywork may require minor touch-ups. The engine compartment may have minor leaks. This vehicle has only minor cosmetic or no rust. The body may have minor scratches or dings and the interior has minor blemishes characteristic of normal wear. The tires match and have at least 50% of tread remaining. Though it may need some reconditioning, it has a clean title history and will pass safety and smog inspection. Some service records are available.</p> <span class="conditon-title">Fair</span> <p>"Fair" condition means that the vehicle has some cosmetic defects that require repairing and/or replacing and requires some mechanical repairs. The paint and bodywork may require refinishing and body repair. The engine compartment has leaks and may require a tune up. This vehicle may have some repairable rust damage. The body has dings, chips, or scratches and the interior has substantial wear, and may have small tears. The tires may need replacing. This vehicle needs servicing, but is still in reasonable running condition. Has a clean title history. A few service records are available.</p></div>';

            if (this.Year > 0) this.fetchMake(this.Year, true);
            if (this.Make != null && this.Make > 0) this.fetchModel(parseInt(this.make, 10), true);
            if (this.Model != null && this.Model > 0) this.fetchTrim(parseInt(this.model, 10), true);
            if (this.ShowModal) {
                document.body.style.position = 'fixed';
                document.body.style.width = '100%';
                document.body.style.WebkitOverflowScrolling = 'auto';
            } else {
                document.body.style.position = 'relative';
                document.body.style.WebkitOverflowScrolling = 'touch';
            }
        },
        methods: {
            closeModal() {
                this.ShowModal = false;
                this.udpdateTrdeIn();
                this.$emit('closeModal', false);
            },
            fetchMake(year, onLoad) {
                this.Year = year;
                // eslint-disable-next-line eqeqeq
                if (!onLoad || this.Make == 0) {
                    this.Make = null;
                    this.Model = null;
                    this.Trim = null;
                }
                this.ShowLoaderMake = true;
                getMakeListSvc('used', year).then((data) => {
                    this.MakeList = this.generateDropDownValues(data, 'makeName', 'makeId');
                    this.$nextTick(() => {
                        if (!onLoad || this.Make === null) {
                            this.Make = 0;
                            this.Model = 0;
                            this.Trim = 0;
                        } else {
                            this.Make = null;
                            this.$nextTick(() => {
                                this.Make = parseInt(this.make, 10);
                            });
                        }
                        this.ShowLoaderMake = false;
                    });
                });
                this.trimValidation(this);
            },
            fetchModel(make, onLoad) {
                // eslint-disable-next-line eqeqeq
                if (!onLoad || this.Model == 0) {
                    this.Model = null;
                    this.Trim = null;
                }
                this.ShowLoaderModel = true;
                getModelListSvc('used', this.Year, this.Make).then((data) => {
                    this.ModelList = this.generateDropDownValues(data, 'modelName', 'modelId');
                    this.ModelListCount = this.ModelList.length;
                    this.$nextTick(() => {
                        if (!onLoad || this.Model === null) {
                            this.Model = this.ModelListCount === 1 ? this.ModelList[0].value : 0;
                            this.fetchTrim(this.Model, false);
                        } else {
                            // eslint-disable-next-line eqeqeq
                            this.Model = this.Model != 0 && onLoad
                                ? this.Model
                                : this.ModelListCount === 1
                                    ? this.ModelList[0].value
                                    : 0;
                            this.$nextTick(() => {
                                this.Model = parseInt(this.model, 10);
                            });
                        }
                        this.ShowLoaderModel = false;
                    });
                });
                this.trimValidation(this);
            },
            updateTrimConditionData() {
                this.trimValidation(this);
            },
            fetchTrim(model, onLoad) {
                // eslint-disable-next-line eqeqeq
                if (!onLoad || this.Trim == 0 || this.trim != 0) {
                    this.Trim = null;
                }
                if (this.Model > 0) {
                    this.ShowLoaderTrim = true;
                    getTrimListSvc(this.Model).then((data) => {
                        if (data && data !== '') {
                            this.TrimList = this.generateDropDownValues(data, 'trimName', 'trimId');
                            this.TrimListCount = this.TrimList.length;
                            this.$nextTick(() => {
                                const trim = Number(this.trim);

                                if ((!onLoad || this.Trim == null) && trim === 0) {
                                    this.Trim = this.TrimListCount === 1 ? this.TrimList[0].value : 0;
                                } else {
                                    this.Trim = trim !== 0 && onLoad
                                        ? trim
                                        : this.TrimListCount === 1
                                            ? this.TrimList[0].value
                                            : 0;
                                }
                                this.ShowLoaderTrim = false;
                                this.trimValidation(this);
                            });
                        }
                    });
                }
            },
            calculatePrice() {
                this.ShowLoader = true;
                this.Mileage = this.Mileage > 0 ? this.Mileage : '0';
                if (this.Trim && this.Mileage && this.ZipCode) {
                    getMarketValuesSvc(this.Trim, this.Mileage, this.ZipCode).then((data) => {
                        if (this.Condition && data && data.tradeIn) {
                            this.ConditionValue = data.tradeIn[this.Condition];
                        }
                        this.$nextTick(() => {
                            this.ShowLoader = false;
                        });
                    });
                }
            },
            generateDropDownValues(data, displayText, value) {
                const list = [];
                if (data !== undefined) {
                    data.forEach((item) => {
                        if (item && item[value] && item[displayText] && item[displayText].trim() !== '') {
                            list.push({
                                text: item[displayText].trim(),
                                value: item[value],
                            });
                        }
                    });
                }
                return list;
            },
            trimValidation: debounce((eventRef) => {
                const self = eventRef;
                self.ShowMileageError = !(parseInt(self.Mileage, 10) > 0);
                // eslint-disable-next-line eqeqeq
                self.IsDisabled = !(self.Trim != 0 && self.Condition !== '' && !self.ShowZipCodeError && !self.ShowZipCodeError && self.Year != 0 && self.Make != 0 && self.Model != 0 && self.Make !== null && self.Model !== null);
                if (!self.IsDisabled) {
                    self.calculatePrice();
                }
                if (self.ShowTrimError === true) {
                    if (self.Trim > 0 && self.Trim !== null) {
                        self.ShowTrimError = false;
                    }
                }
                if (self.Mileage !== '' && self.Mileage !== null && !(self.Trim > 0)) {
                    self.ShowTrimError = true;
                }
            }, 800),
            trimValidationMileage() {
                this.ShowTrimError = !(this.Trim > 0) && this.Mileage !== '' && this.Mileage !== null;
                // eslint-disable-next-line eqeqeq
                if (this.Mileage == 0) {
                    this.ShowTrimError = !(this.Trim > 0);
                }
                this.trimValidation(this);
            },
            convertCurrency(figure) {
                return Accounting.formatNumber(Math.abs(figure));
            },
            fetchSelectedValue(list, value) {
                let result = '';
                if (value) {
                    const selectedOption = list.find(element => element.value === value);
                    result = selectedOption !== undefined ? selectedOption.text : '';
                }
                return result;
            },
            udpdateTrdeIn() {
                this.$emit('updateTradeIn', {
                    condition: this.ConditionValue, year: this.Year, make: this.Make, model: this.Model, trim: this.Trim, mileage: this.Mileage, zipcode: this.ZipCode, ConditionVal: this.Condition,
                });
            },
            getLocationByZip(zip) {
                this.ZipCode = zip;
                if (this.zipCodeValidator()) {
                    this.ShowZipCodeError = false;
                    GetLocation.methods.GetZipCode(this.ZipCode, this.checkLocationResponse);
                } else {
                    this.ShowZipCodeError = true;
                }
            },
            zipCodeValidator() {
                const zipCodeRegEx = /^\d{5}$/;
                return zipCodeRegEx.test(this.ZipCode) && this.ZipCode !== '';
            },
            checkLocationResponse(val) {
                if (val.city !== '') {
                    this.updateLocation(val);
                } else {
                    this.ShowZipCodeError = true;
                }
            },
            updateLocation(val) {
                this.$nextTick(() => {
                    this.Location = val;
                    this.trimValidation(this);
                    this.PopperContent1 = `<div class="popup-content large-content"><p>This is the amount you can expect to receive when you trade in your car to a dealer. This value is determined based on the style, condition, mileage and options indicated.</p><p>&copy; ${new Date().getFullYear()} by Kelley Blue Book Co., Inc. ${this.startDate} - ${this.endDate} Edition for ${this.Location.zipCode}. All Rights Reserved. The specific information required to determine the value for this particular vehicle was supplied by the person generating this report. Vehicle valuations are opinions and may vary from vehicle to vehicle. Actual valuations will vary based upon market conditions, specifications, vehicle condition or other particular circumstances pertinent to this particular vehicle or the transaction or the parties to the transaction. This report is intended for the individual use of the person generating this report only and shall not be sold or transmitted to another party. Kelley Blue Book assumes no responsibility for errors or omissions.</p></div>`;
                    this.PopperContentMob = `<div class="popup-content large-content"><p>This is the amount you can expect to receive when you trade in your car to a dealer. This value is determined based on the style, condition, mileage and options indicated.</p><p>&copy;  ${new Date().getFullYear()} Kelley Blue Book Co., Inc. All rights reserved. ${this.startDate} - ${this.endDate} Edition for  ${StringFormat.capitalize(this.Location.city)}, ${this.Location.state}  ${this.Location.zipCode}. Kelley Blue Book assumes no responsibility for errors or omissions.</p></div>`;
                });
            },
        },
    };
</script>
